import React from 'react';
import { Provider } from 'react-redux';
import { Store } from './StoreContainer';

export default ({ element, props }: { element: any; props: any }) => {
  const store = Store;
  return (
    <Provider store={store} {...props}>
      {element}
    </Provider>
  );
};
